import { lazy, Suspense } from 'react';

import type { MapPin } from './MapViewImpl';
import { Spinner } from './Spinner';

// Lazy-loaded so Leaflet + react-leaflet (~200 kB gzipped) stay out of the
// initial bundle — they're only needed on 2 admin routes and the masjid-create
// form. Same pattern as the Firebase Messaging split.
const MapViewImpl = lazy(async () => ({ default: (await import('./MapViewImpl')).MapViewImpl }));

export type { MapPin } from './MapViewImpl';

interface MapViewProps {
  pins?: readonly MapPin[];
  onPinDrop?: (lat: number, lng: number) => void;
  droppedPin?: { lat: number; lng: number } | null;
  height?: number | string;
  center?: [number, number];
  zoom?: number;
}

export function MapView(props: MapViewProps): JSX.Element {
  return (
    <Suspense
      fallback={
        <div
          style={{
            height: props.height ?? 400,
            display: 'grid',
            placeItems: 'center',
            background: 'var(--color-surface-2)',
            borderRadius: 'var(--radius-md)',
          }}
        >
          <Spinner />
        </div>
      }
    >
      <MapViewImpl {...props} />
    </Suspense>
  );
}
